module.exports = __webpack_public_path__ + "img/xinisok.dd17ef86.png";